// internal
import { ListData } from '@app/store/typings/state/global.d';
import {
  UserData,
  FormUpdateUser,
  UserDataInBrand,
  UserDataInProject,
  UserMeta,
  ManageTable,
  FilterEndUser,
} from '@app/typings/services/user';

export const KEY_USER_SELECT_FETCH = 'KEY_USER_SELECT_FETCH';
export interface FetchSelectUser {
  type: typeof KEY_USER_SELECT_FETCH;
  payload: string;
}

export const KEY_USER_FETCH_BY_NAME = 'KEY_USER_FETCH_BY_NAME';
export interface FetchUserByName {
  type: typeof KEY_USER_FETCH_BY_NAME;
  payload: FetchUserByNameParams;
}

export const KEY_USER_SELECT_SET_DATA = 'KEY_USER_SELECT_SET_DATA';
export interface UserSetDataSelect {
  type: typeof KEY_USER_SELECT_SET_DATA;
  payload: ListData[];
}

export const KEY_USER_SELECT_SET_DATA_RESERVATION = 'KEY_USER_SELECT_SET_DATA_RESERVATION';
export interface UserSetDataSelectReservation {
  type: typeof KEY_USER_SELECT_SET_DATA_RESERVATION;
  payload: ListData[];
}

export const KEY_USER_MYUSER_FETCH = 'KEY_USER_MYUSER_FETCH';
export interface MyUserFetch {
  type: typeof KEY_USER_MYUSER_FETCH;
}

export const KEY_USER_MYUSER_SET_DATA = 'KEY_USER_MYUSER_SET_DATA';
export interface MyUserSetData {
  type: typeof KEY_USER_MYUSER_SET_DATA;
  payload: UserData;
}

export const KEY_USER_MYUSER_CLEAR = 'KEY_USER_MYUSER_CLEAR';
export interface MyUserClear {
  type: typeof KEY_USER_MYUSER_CLEAR;
}

export const KEY_USER_UPDATE = 'KEY_USER_UPDATE';
export interface UserUpdate {
  type: typeof KEY_USER_UPDATE;
  payload: {
    data: FormUpdateUser;
    userId: string;
  };
}

export const KEY_USER_FETCH_INBRAND = 'KEY_USER_FETCH_INBRAND';
export interface FetchUserInBrand {
  type: typeof KEY_USER_FETCH_INBRAND;
  payload: {
    offset: number;
    limit: number;
  };
}

export const KEY_USER_INBRAND_SETDATA = 'KEY_USER_INBRAND_SETDATA';
export interface SetDataUserInBrand {
  type: typeof KEY_USER_INBRAND_SETDATA;
  payload: UserDataInBrand[];
}

export const KEY_USER_INBRAND_CLEAR = 'KEY_USER_INBRAND_CLEAR';
export interface ClearDataUserInBrand {
  type: typeof KEY_USER_INBRAND_CLEAR;
}

export const KEY_USER_INBRAND_WITHID = 'KEY_USER_INBRAND_WITHID';
export interface FetchUserInBrandWithId {
  type: typeof KEY_USER_INBRAND_WITHID;
  payload: string;
}

export const KEY_USER_INBRAND_SETCURRENT = 'KEY_USER_INBRAND_SETCURRENT';
export interface SetUserInBrandCurrent {
  type: typeof KEY_USER_INBRAND_SETCURRENT;
  payload: UserData;
}

export const KEY_USER_INVITE_INBRAND = 'KEY_USER_INVITE_INBRAND';
export interface InviteUserInBrand {
  type: typeof KEY_USER_INVITE_INBRAND;
  payload: {
    email: string;
    roleId: string;
  };
}

export const KEY_USER_BRAND_SETMETA = 'KEY_USER_BRAND_SETMETA';
export interface UserInBrandSetMeta {
  type: typeof KEY_USER_BRAND_SETMETA;
  payload: UserMeta;
}

export const KEY_USER_FETCH_INPROJECT = 'KEY_USER_FETCH_INPROJECT';
export interface FetchUserInProject {
  type: typeof KEY_USER_FETCH_INPROJECT;
  payload: FilterEndUser;
}

export const KEY_USER_INPROJECT_SETDATA = 'KEY_USER_INPROJECT_SETDATA';
export interface SetDataUserInProject {
  type: typeof KEY_USER_INPROJECT_SETDATA;
  payload: {
    data: UserDataInProject[];
    meta: ResponseMeta;
  };
}

export const KEY_USER_INPROJECT_CLEAR = 'KEY_USER_INPROJECT_CLEAR';
export interface ClearDataUserInProject {
  type: typeof KEY_USER_INPROJECT_CLEAR;
}

export const KEY_USER_INPROJECT_WITHID = 'KEY_USER_INPROJECT_WITHID';
export interface FetchUserInProjectWithId {
  type: typeof KEY_USER_INPROJECT_WITHID;
  payload: string;
}

export const KEY_USER_INPROJECT_SETCURRENT = 'KEY_USER_INPROJECT_SETCURRENT';
export interface SetUserInProjectCurrent {
  type: typeof KEY_USER_INPROJECT_SETCURRENT;
  payload: UserData;
}

export type InviteUserBody = {
  email: string;
  roleId: string;
  groupIds?: string[];
};
export const KEY_USER_INVITE_INPROJECT = 'KEY_USER_INVITE_INPROJECT';
export interface InviteUserInProject {
  type: typeof KEY_USER_INVITE_INPROJECT;
  payload: InviteUserBody;
}

export const KEY_USER_PROJECT_SETMETA = 'KEY_USER_PROJECT_SETMETA';
export interface UserInProjectSetMeta {
  type: typeof KEY_USER_PROJECT_SETMETA;
  payload: UserMeta;
}

export const KEY_USER_INVITE_FETCH = 'KEY_USER_INVITE_FETCH';
export interface UserInviteFetch {
  type: typeof KEY_USER_INVITE_FETCH;
}

export const KEY_USER_UPDATE_INVITE = 'KEY_USER_UPDATE_INVITE';
export interface UserUpdateInvite {
  type: typeof KEY_USER_UPDATE_INVITE;
}

export const KEY_USER_DELETE = 'KEY_USER_DELETE';
export interface DeleteUserAccount {
  type: typeof KEY_USER_DELETE;
  payload: {
    userId: string;
  };
}

export const KEY_USER_CHANGE_PASSWORD = 'KEY_USER_CHANGE_PASSWORD';
export interface UserChangePassword {
  type: typeof KEY_USER_CHANGE_PASSWORD;
  payload: {
    password: string;
    userId?: any;
    pushEndUser?: boolean;
  };
}

export const KEY_USER_UPLOAD_PICTURE = 'KEY_USER_UPLOAD_PICTURE';
export interface UserUploadPicture {
  type: typeof KEY_USER_UPLOAD_PICTURE;
  payload: {
    userId: string;
    file: any;
  };
}

export const KEY_USER_SET_IS_EDITABLE = 'KEY_USER_SET_IS_EDITABLE';
export interface UserSetIsEditable {
  type: typeof KEY_USER_SET_IS_EDITABLE;
  payload: {
    isEditable: boolean;
  };
}

export const KEY_USER_SET_FACE_ID = 'KEY_USER_SET_FACE_ID';
export interface UserSetFaceUrl {
  type: typeof KEY_USER_SET_FACE_ID;
  faceUrl: string;
}

export const KEY_USER_MEMBER_INVITE = 'KEY_USER_MEMBER_INVITE';
export interface InviteUserMember {
  type: typeof KEY_USER_MEMBER_INVITE;
  payload: InviteMemberBody;
}

export const KEY_USER_CHECKBOX = 'KEY_USER_CHECKBOX';
export interface CheckboxUser {
  type: typeof KEY_USER_CHECKBOX;
  payload: string[];
}

export const KEY_USER_MANAGE_TABLE = 'KEY_USER_MANAGE_TABLE';
export interface ManageTableUser {
  type: typeof KEY_USER_MANAGE_TABLE;
  payload: ManageTable;
}

export type UserType =
  | CheckboxUser
  | FetchSelectUser
  | UserSetDataSelect
  | UserSetDataSelectReservation
  | MyUserFetch
  | MyUserSetData
  | MyUserClear
  | UserUpdate
  | FetchUserInBrand
  | SetDataUserInBrand
  | ClearDataUserInBrand
  | FetchUserInBrandWithId
  | SetUserInBrandCurrent
  | InviteUserInBrand
  | UserInBrandSetMeta
  | FetchUserInProject
  | SetDataUserInProject
  | ClearDataUserInProject
  | FetchUserInProjectWithId
  | SetUserInProjectCurrent
  | InviteUserInProject
  | UserInProjectSetMeta
  | UserInviteFetch
  | UserUpdateInvite
  | UserChangePassword
  | UserUploadPicture
  | DeleteUserAccount
  | UserSetIsEditable
  | InviteUserMember
  | ManageTableUser
  | UserSetFaceUrl
  | FetchUserByName;
